import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import Card from './Card';
import colors from '../../config/colors';

/**
 * DeviceInfoCard - Shows device identification info (Web ID, IP, MAC, Last Connected)
 */
function DeviceInfoCard({
    webId,
    ipAddress,
    macAddress,
    lastConnected,
    style
}) {
    return (
        <Card style={style}>
            <InfoRow label="Web ID" value={webId} />
            <InfoRow label="IP" value={ipAddress} />
            <InfoRow label="MAC" value={macAddress} />
            <InfoRow label="Last Connected" value={lastConnected} isLast />
        </Card>
    );
}

function InfoRow({ label, value, isLast }) {
    return (
        <View style={[styles.row, !isLast && styles.rowBorder]}>
            <Text style={styles.label}>{label}</Text>
            <Text style={styles.value}>{value}</Text>
        </View>
    );
}

const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingVertical: 8,
    },
    rowBorder: {
        borderBottomWidth: 1,
        borderBottomColor: '#f0f0f0',
    },
    label: {
        fontWeight: 'bold',
        color: colors.dark,
        fontSize: 14,
    },
    value: {
        color: colors.medium,
        fontSize: 14,
        flexShrink: 1,
        textAlign: 'right',
        marginLeft: 8,
    },
});

export default DeviceInfoCard;
